/**
 * My Badges (DEP-9449).
 *
 * One badge size for the whole page (AC5, AC7): the artwork is the content
 * here, and a milestone tile that did not match the grid below it read as a
 * different kind of thing rather than the same badge at a different stage.
 */
export const BADGE_SIZE = 96

/** AC5: four badge positions fit; anything beyond that scrolls. */
export const VISIBLE_BADGE_POSITIONS = 4

export const BADGE_GAP = 16

/**
 * AC2 default copy, used until the blood center writes its own in
 * System Configurations. Kept here rather than seeded into every tenant's
 * database so that changing the wording is a deploy, not a migration.
 */
export const DEFAULT_BANNER_HEADING = 'You make a difference!'
export const DEFAULT_BANNER_MESSAGE =
  'Thank you for your generosity and commitment to saving lives.'
